import Seo from "@/components/Seo";
import { PageHero, Container, Reveal, CtaBand } from "@/components/public/parts";
import { Phone, ClipboardList, Handshake, CalendarCheck } from "lucide-react";

const STEPS = [
  { icon: Phone, title: "Reach Out", text: "Submit an inquiry or referral online, or call our team. We'll listen and answer your questions." },
  { icon: ClipboardList, title: "Assessment", text: "We meet to understand goals, needs, preferences and eligibility for services." },
  { icon: Handshake, title: "Personalized Plan", text: "Together we build a person-centered support plan tailored to the individual." },
  { icon: CalendarCheck, title: "Ongoing Support", text: "Compassionate services begin — and adapt as needs and goals evolve over time." },
];

export default function HowItWorks() {
  return (
    <>
      <Seo title="How It Works | Love For Mankind" description="Learn the simple, supportive path to getting started with Love For Mankind services in Ohio." path="/how-it-works" />
      <PageHero eyebrow="The Process" title="A simple, supportive path to care" sub="From first contact to ongoing support, here's how we work alongside you." breadcrumbs={[{ label: "Home", to: "/" }, { label: "How It Works" }]} />
      <Container className="py-16 lg:py-24">
        <div className="space-y-10">
          {STEPS.map((st, i) => (
            <Reveal key={i} delay={i * 0.05}>
              <div className="flex items-start gap-6 lg:gap-10">
                <div className="shrink-0 relative">
                  <div className="w-16 h-16 rounded-2xl bg-primary text-primary-foreground flex items-center justify-center"><st.icon className="w-7 h-7" /></div>
                </div>
                <div className="flex-1 pb-10 border-b border-border">
                  <span className="text-gold font-heading font-bold text-sm">STEP {i + 1}</span>
                  <h2 className="font-heading text-2xl lg:text-3xl font-bold mt-1">{st.title}</h2>
                  <p className="text-[17px] text-muted-foreground mt-3 leading-[1.75] max-w-2xl">{st.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </Container>
      <CtaBand />
    </>
  );
}
